import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import { clickOutside } from "./directives/clickOutside";

import "./assets/tailwind.css";

const app = createApp(App);
const pinia = createPinia();

// Register custom directive
app.directive("click-outside", clickOutside);

app.use(router);
app.use(pinia);

app.mount("#app");

// import { createApp } from 'vue';

// import router from './router';
// import App from './App.vue';
// import Toast from 'vue-toastification';
// import { clickOutside } from './directives/clickOutside';
// import 'vue-toastification/dist/index.css';
// import './index.css';

// const app = createApp(App);
// const pinia = createPinia();

// // Register custom directive
// app.directive('click-outside', clickOutside);

// app.use(pinia);
// app.use(router);
// app.use(Toast, {
//   position: 'top-right',
//   timeout: 5000,
//   closeOnClick: true,
//   pauseOnFocusLoss: true,
//   pauseOnHover: true,
//   draggable: true,
//   draggablePercent: 0.6,
//   showCloseButtonOnHover: false,
//   hideProgressBar: true,
//   closeButton: 'button',
//   icon: true,
//   rtl: false,
// });

// app.mount('#app');
